import React, { useRef } from 'react';
import { useEffectOnce } from 'react-use';
import { ApiService, UserConfig } from '../../CustomFormsWorkflow.meta';

interface Props {
  formSessionId: string;
  userConfig: UserConfig;
  mode?: 'interactive' | 'preview' | 'saveForLater';
  onFormReady(evtDetail: { service: ApiService }): void;
}

export const CustomFormsComponent = ({
  formSessionId,
  mode = 'interactive',
  userConfig,
  onFormReady,
}: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffectOnce(() => {
    const handleCustomFormsReady = evt => {
      onFormReady(evt.detail);
    };

    const container = containerRef.current;

    if (container) {
      const existingComponent = container.querySelector('custom-forms-session-web');

      if (existingComponent) {
        existingComponent.remove();
      }

      const component = document.createElement('custom-forms-session-web');

      // Remove focus outline introduced by the focus-visible polyfill
      component.style.outline = 'none';

      component.setAttribute('form-session-id', formSessionId);
      component.setAttribute('user-config', JSON.stringify(userConfig));
      component.setAttribute('mode', mode);
      component.setAttribute('options', JSON.stringify({ hideButtons: true }));

      component.addEventListener('customFormsReady', handleCustomFormsReady);

      container.appendChild(component);
    }

    return () => {
      if (container) {
        const component = container.querySelector('custom-forms-session-web');

        if (component) {
          component.removeEventListener('customFormsReady', handleCustomFormsReady);
          component.remove();
        }
      }
    };
  });

  return <div ref={containerRef} css="height: 100%" />;
};
